import { createSelector } from 'reselect';
import getSelectedBackground from './getSelectedBackground';

const getBackgroundUrl = createSelector([getSelectedBackground], (background) => (background ? background.url : ''));

export default getBackgroundUrl;
